import { LogLevel } from './logger.interfaces';
import { SimpleLogger } from './simple-logger';
export var logger = new SimpleLogger();
logger.serverLevel = LogLevel.silent;
//# sourceMappingURL=logger.js.map